import { buildModelManager } from "../builder.js";
const DefaultOfficialWhatsappTemplateSelection = {
  __typename: true,
  id: true,
  buttonUrlLink: true,
  buttonUrlLink2: true,
  createdAt: true,
  customerId: true,
  name: true,
  updatedAt: true,
  urlButtonsInCards: true
};
const modelApiIdentifier = "officialWhatsappTemplate";
const pluralModelApiIdentifier = "officialWhatsappTemplates";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByName",
    findByField: "name",
    findByVariableName: "name",
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByName",
    findByField: "name",
    findByVariableName: "name",
    modelApiIdentifier,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createOfficialWhatsappTemplate",
    operationReturnType: "CreateOfficialWhatsappTemplate",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      officialWhatsappTemplate: { required: false, type: "CreateOfficialWhatsappTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkCreateOfficialWhatsappTemplates",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateOfficialWhatsappTemplatesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultOfficialWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "updateOfficialWhatsappTemplate",
    operationReturnType: "UpdateOfficialWhatsappTemplate",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      officialWhatsappTemplate: { required: false, type: "UpdateOfficialWhatsappTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateOfficialWhatsappTemplates",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateOfficialWhatsappTemplatesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultOfficialWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "deleteOfficialWhatsappTemplate",
    operationReturnType: "DeleteOfficialWhatsappTemplate",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteOfficialWhatsappTemplates",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertOfficialWhatsappTemplate",
    operationReturnType: "UpsertOfficialWhatsappTemplate",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      officialWhatsappTemplate: { required: false, type: "UpsertOfficialWhatsappTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateOfficialWhatsappTemplateResult": { hasReturnType: false },
      "... on UpdateOfficialWhatsappTemplateResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultOfficialWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertOfficialWhatsappTemplates",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertOfficialWhatsappTemplatesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultOfficialWhatsappTemplateSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "officialWhatsappTemplateGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const OfficialWhatsappTemplateManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultOfficialWhatsappTemplateSelection,
  operations
);
export {
  DefaultOfficialWhatsappTemplateSelection,
  OfficialWhatsappTemplateManager
};
//# sourceMappingURL=OfficialWhatsappTemplate.js.map
